<template>
  <div aria-live="polite" class="absolute left-0 z-10" :class="positionClasses">
    <Transition
      enter-active-class="transition-opacity duration-150 ease-out"
      leave-active-class="transition-opacity duration-150 ease-in"
      enter-from-class="opacity-0"
      leave-to-class="opacity-0"
    >
      <div
        v-if="show"
        :class="[
          'min-w-300',
          'max-w-500',
          'rounded-md',
          'bg-surface-primary',
          'py-16',
          'pe-16',
          'ps-8',
          'border-2',
          'border-l-6',
          'shadow-md',
          borderColor,
        ]"
      >
        <div class="flex flex-row gap-8 items-start">
          <nuxt-icon
            filled
            :name="icon"
            class="text-[2.4rem] shrink-0"
            aria-hidden="true"
          />
          <p>
            <slot />
          </p>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  show: boolean;
  type?: 'success' | 'warning' | 'error' | 'info';
  position?: 'top' | 'bottom';
}

const props = withDefaults(defineProps<Props>(), {
  type: 'warning',
  position: 'bottom',
});

const icon = computed(() => {
  switch (props.type) {
    case 'success':
      return 'check-circle-green';
    case 'warning':
      return 'alert-circle-orange';
    case 'error':
      return 'alert-circle-red';
    case 'info':
      return 'alert-circle-blue';
    default:
      return 'alert-circle-orange';
  }
});

const borderColor = computed(() => {
  switch (props.type) {
    case 'success':
      return 'border-border-success';
    case 'warning':
      return 'border-border-warning';
    case 'error':
      return 'border-border-error';
    case 'info':
      return 'border-border-information';
    default:
      return 'border-border-warning';
  }
});

const positionClasses = computed(() => {
  if (props.position === 'top') {
    return 'bottom-full mb-8';
  }
  return 'top-full mt-8';
});
</script>
